<template>
  <div class="c-plan g-container">
    <!-- 导航 -->
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem :to="{name: 'plan', query: {id: plan.campaignFeedId, t: 'edit'}}">
        <Icon type="ios-home-outline"></Icon> 设置推广计划
      </BreadcrumbItem>
      <BreadcrumbItem>
        <Icon type="logo-buffer"></Icon> 设置推广单元
      </BreadcrumbItem>
    </Breadcrumb>

    <moduler
      v-for="item in subModules"
      :media="media"
      :key="item.id"
      :name="item.href"
      :title="item.name">
      <!-- 基础信息 -->
      <template v-if="item.href === 'plan_basic'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广计划</span>
          </Col>
          <Col span="12" style="position: relative">
            <span>{{plan.campaignFeedName}}</span>
            <div v-if="plan.campaign_ids.length > 1" class="c-group-desc"> （共{{plan.campaign_ids.length}}条计划组）</div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广单元名称</span>
          </Col>
          <Col span="12">
            <input-len
              v-model="plan.plan_name"
              placeholder="最大90个字符，1个中文等于2个字符"
              width="420"
              :max="90"
              :disabled="editState"></input-len>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">游戏平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.ch_platform_id" type="button" @on-change="changePlatform">
              <Radio :label="1" :disabled="editState || plan.landing_type === 'APP'">Android</Radio>
              <Radio :label="2" :disabled="editState || plan.landing_type === 'APP'">iOS</Radio>
              <Radio :label="3" :disabled="editState">小程序</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">投放游戏</span>
          </Col>
          <Col span="12">
            <auto-complete
              :data="platformGameData"
              v-model="plan.game_id"
              placeholder="请选择推广游戏"
              :disabled="editState"
              @on-select="handleGame"></auto-complete>
          </Col>
        </Row>
        <!-- agent -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">是否代投</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.agent" type="button" @on-change="changeAgent">
              <Radio label="NOAGENT" :disabled="editState">非代投</Radio>
              <Radio label="AGENT" :disabled="editState">代投</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="plan.agent === 'AGENT'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">代投账号</span>
          </Col>
          <Col span="12">
            <auto-complete
              :data="agentData"
              v-model="plan.proxy_account_id"
              placeholder="请选择代投账号"
              :disabled="editState"
              @on-select="handleAgent"></auto-complete>
          </Col>
        </Row>
        <!-- landing_type -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.landing_type" type="button">
              <Radio label="LINK" disabled>落地页</Radio>
              <Radio label="APP" disabled>App应用</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="plan.landing_type === 'LINK'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">落地页地址</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.page_addr"
              placeholder="选择内部落地页"
              style="width: 420px; margin-right: 6px"
              :disabled="editState" readonly />
            <Button type="primary" @click="linkModel = true" style="margin-right: 0" :disabled="editState">选择落地页</Button>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">游戏包名称</span>
          </Col>
          <Col span="12">
            <Input v-model="plan.package" placeholder="App应用包名称" disabled style="width: 280px" />
          </Col>
        </Row>
        <!-- 联盟流量监测链接 -->
        <!-- <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">联盟流量监测链接</span>
          </Col>
          <Col span="12">
            <i-switch v-model="plan.union_flag" :disabled="editState" />
          </Col>
        </Row> -->
        <!-- managePlan -->
        <Row class="row-item item-flex-start" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划管家</span>
          </Col>
          <Col span="12">
            <Button type="primary" @click="butlerModel = true" :disabled="editState">
              <span v-if="managePlan.length">更新管家</span>
              <span v-else>选择管家</span>
            </Button>
            <dl v-for="(manage, id) in managePlan" :key="id" class="c-butler">
              <dd>
                <span>{{manage.ruleName}}</span>
                <span v-show="!editState" class="c-butler-del" @click="managePlan = []">删除</span>
              </dd>
            </dl>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">回调开关</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-Switch
              v-model="plan.callback_switch"
              :disabled="editState || !isAndroid"
              :true-value="1"
              :false-value="0" />
            <span v-if="!isAndroid" style="color: #FF0000;margin-left: 1em;">iOS请务必选择需要的回调类型</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="plan.callback_switch">
          <Col span="3" class="col-item">
            <span class="item-field">回调类型</span>
          </Col>
          <Col span="12" class="col-flex">
            <CheckboxGroup v-model="plan.callback_settings">
              <Checkbox label="callbackTypeActive" disabled>激活</Checkbox>
              <Checkbox label="callbackTypeRegist" disabled>注册</Checkbox>
              <Checkbox label="callbackTypeRecharge" disabled>付费</Checkbox>
              <Checkbox label="callbackTypeMoney" disabled>订单金额</Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>
        <!-- batch -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">批量建立</span>
          </Col>
          <Col span="12">
            <i-switch v-model="batch" :disabled="editState" @on-change="changeBatch" />
          </Col>
        </Row>
        <Row v-if="batch" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Poptip
              trigger="hover"
              placement="top-start"
              width="410"
              word-wrap
              content="始末数字最多相差10">
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field">数量</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.bitch_add_begin"
              placeholder="起始数"
              style="width: 60px"
              @on-blur="inputTrim('bitch_add_begin', plan.bitch_add_begin, plan)" />
            <span>&nbsp; ~ &nbsp;</span>
            <Input
              v-model="plan.bitch_add_end"
              placeholder="结束数"
              style="width: 60px"
              @on-blur="inputTrim('bitch_add_end', plan.bitch_add_end, plan)" />
          </Col>
        </Row>
      </template>

      <!-- 版位信息 -->
      <template v-if="item.href === 'plan_target'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放流量</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="ftypes" type="button" @on-change="changeFtypes">
              <Radio label="NONE" :disabled="editState">优选流量</Radio>
              <Radio label="NAME" :disabled="editState">按场景选择投放位</Radio>
              <Radio label="TYPE" :disabled="true">百青藤</Radio>
            </RadioGroup>

          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="ftypes === 'NAME'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <Mixcheck v-model="plan.ftypes">
              <Check-item :label="1" :disabled="editState">百度信息流</Check-item>
              <Check-item :label="2" :disabled="editState">贴吧信息流</Check-item>
              <!-- <Check-item :label="4" :disabled="editState">百度联盟媒体</Check-item> -->
              <Check-item :label="8" :disabled="editState">好看视频</Check-item>
              <Check-item :label="64" :disabled="editState">百度小说</Check-item>
            </Mixcheck>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放版位</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="plan.producttypes">
              <Radio-item :label="0">默认</Radio-item>
              <Check-item :label="1" :disabled="disabledptype">列表页</Check-item>
              <!-- <Check-item :label="2" :disabled="disabledptype">详情页（白名单功能）</Check-item> -->
            </Mixcheck>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="bindMediaType">
          <Col span="3" class="col-item">
            <span class="item-field">媒体分类</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.mediaCategoriesBindType" type="button" @on-change="radioChange('mediagoryData')">
              <Radio label="0">不限</Radio>
              <Radio label="1">媒体定向</Radio>
              <Radio label="2">媒体屏蔽</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="plan.mediaCategoriesBindType !== '0'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <selecter
              v-model="mult_mediagory"
              :data="mediagoryData"
              :title="['按媒体分类']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>
      </template>

      <!-- 用户定向 -->
      <template v-if="item.href === 'plan_client'">

        <!-- 人群包 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">人群包</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="audienceMode" type="button" @on-change="changeRetarget">
              <Radio label="NONE">不限</Radio>
              <Radio label="AUDIENCE">定向排除人群</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="audienceMode === 'AUDIENCE'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <retarget
              title="选定人群"
              :data="audienceData"
              :use-word="disCrowd"
              @on-clear="clearRetarget"
              @on-delete="delRetarget" />
          </col>
        </Row>

        <!-- region -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">地域</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="allRegion" type="button" @on-change="radioChange('cityData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM">按省市</Radio>
              <!-- <Radio :label="2">按区县</Radio> -->
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="allRegion === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <selecter
              v-model="mult_city"
              :data="cityData"
              :title="['省份', '城市']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">性别</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.sex" type="button">
              <Radio label="0">不限</Radio>
              <Radio label="1">女</Radio>
              <Radio label="2">男</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">年龄</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="ageMode" type="button" @on-change="changeAge">
              <Radio label="NONE">不限</Radio>
              <Radio label="RANGE">指定年龄段</Radio>
              <Radio label="CUSTOM">自定义年龄</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="ageMode === 'RANGE'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18" class="col-flex">
            <CheckboxGroup v-model="plan.age">
              <Checkbox label="1">18岁以下</Checkbox>
              <Checkbox label="2">18-24岁</Checkbox>
              <Checkbox label="3">25-34岁</Checkbox>
              <Checkbox label="4">35-44岁</Checkbox>
              <Checkbox label="5">45-54岁</Checkbox>
              <Checkbox label="6">54岁以上</Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="ageMode === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <range-age v-model="plan.customAge" :offset="9" />
          </Col>
        </Row>

        <!-- 兴趣 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">兴趣</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="interestType" type="button" @on-change="radioChange('interestData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM" :disabled="useCrowd">按兴趣分类</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="interestType === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <selecter
              v-model="mult_interest"
              :data="interestData"
              :title="['可选兴趣']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>

        <!-- 意图词 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">意图词</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="keywordsType" type="button" @on-change="changeKeyword">
              <Radio label="NONE">不限</Radio>
              <Radio label="ADD" :disabled="useCrowd">添加意图词</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <template v-if="keywordsType === 'ADD'">
          <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="20">
            <keyword-interest
              v-model="plan.keywords"
              :account="plan.ad_account_id"
              @on-select="appendMultword"
              @on-delete="deleteMultWord"
              @on-clear="$set(plan, 'keywords', [])" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="1" style="margin-right: 12px;">&nbsp;</Col>
          <Col span="3" class="col-item">
            <span class="item-field">用户行为</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.keywordsExtend" type="button">
              <Radio label="1">全网行为</Radio>
              <Radio label="2">历史搜索</Radio>
            </RadioGroup>
          </Col>
          </Row>
        </template>

        <!-- 贴吧信息流 -->
        <Row class="row-item" :gutter="12" v-if="bindTiebaType">
          <Col span="3" class="col-item">
            <span class="item-field">贴吧主题</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="directoriesType" type="button" @on-change="radioChange('themeData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM">自定义</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="directoriesType === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <selecter
              v-model="mult_theme"
              :data="themeData"
              :title="['按主题']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="bindBaiduType">
          <Col span="3" class="col-item">
            <span class="item-field">文章分类</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="article" type="button" @on-change="radioChange('articleData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM">自定义</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="article === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="16">
            <selecter
              v-model="mult_article"
              :data="articleData"
              :title="['按分类']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>

        <!-- APP定向 -->
        <Row class="row-item" :gutter="12" v-if="plan.ch_platform_id === 1">
          <Col span="3" class="col-item">
            <span class="item-field">APP定向</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="appType" type="button">
              <Radio label="all">不限</Radio>
              <Radio label="category">按APP分类</Radio>
              <Radio label="custom">按APP名称</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="appType === 'category'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="20">
            <selecter
              v-model="mult_gategory"
              :data="gategoryData"
              :title="['按APP分类']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="appType === 'custom'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <adder
              v-model="mult_app"
              :account="plan.ad_account_id"
              placeholder="请输入APP名称" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="appType !== 'all'">
          <Col span="1" style="margin-right: 12px;">&nbsp;</Col>
          <Col span="3" class="col-item">
            <span class="item-field">定向逻辑</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="appBehavior">
              <radio-item :label="2">安装</radio-item>
              <radio-item :label="4">排除安装</radio-item>
            </Mixcheck>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.device" type="button">
              <Radio label="2" disabled>Android</Radio>
              <Radio label="1" disabled>iOS</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- iOS版本 -->
        <Row class="row-item" :gutter="12" v-if="plan.device === '1'">
          <Col span="3" class="col-item">
            <span class="item-field">iOS版本</span>
          </Col>
          <Col span="18">
            <Mixcheck v-model="plan.iosVersion">
              <radio-item label="0">不限</radio-item>
              <check-item v-for="item in ios_version" :label="item.key" :key="item.key">
                {{item.label}}
              </check-item>
            </Mixcheck>
          </Col>
        </Row>

        <!-- 安卓版本 -->
        <Row class="row-item" :gutter="12" v-if="plan.device === '2'">
          <Col span="3" class="col-item">
            <span class="item-field">安卓版本</span>
          </Col>
          <Col span="18">
            <Mixcheck v-model="plan.androidVersion">
              <radio-item label="0">不限</radio-item>
              <check-item v-for="item in android_version" :label="item.key" :key="item.key">
                {{item.label}}
              </check-item>
            </Mixcheck>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">网络</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.net" type="button">
              <Radio label="0">不限</Radio>
              <Radio label="1">WIFI</Radio>
              <Radio label="2">数据网络</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- 人生阶段 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">人生阶段</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="plan.lifeStage" type="button">
              <radio-item label="0">不限</radio-item>
              <check-item label="1">未婚</check-item>
              <check-item label="2">已婚</check-item>
              <check-item label="3">孕期</check-item>
              <check-item label="4">家有儿女</check-item>
            </Mixcheck>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">学历</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="plan.education">
              <radio-item label="0">不限</radio-item>
              <check-item label="1">大学及以上</check-item>
              <check-item label="2">高中及以下</check-item>
              <check-item label="3">大专</check-item>
            </Mixcheck>
          </Col>
        </Row>

        <!-- 智能扩量 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">智能扩量</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-Switch v-model="plan.autoExpansion" true-value="1" false-value="0" />
          </Col>
        </Row>

        <!-- 排除已转化用户 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">排除已转化用户</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.excludeTrans" type="button">
              <Radio label="0">不限</Radio>
              <Radio label="3">同单元</Radio>
              <Radio label="2">同计划</Radio>
              <Radio label="1">同账户</Radio>
            </RadioGroup>
          </Col>
        </Row>
      </template>

      <!-- 出价设置 -->
      <template v-if="item.href === 'plan_price'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">优化目标</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.bidtype" type="button">
              <Radio :label="3" :disabled="editState">转化</Radio>
              <!-- <Radio :label="1" :disabled="editState">点击量</Radio>
              <Radio :label="2" :disabled="editState">展现量</Radio> -->
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="plan.bidtype === 3 && editState">
          <Col span="3" class="col-item">
            <span class="item-field">转化名称</span>
          </Col>
          <Col span="12">
            <Select v-model="plan.appTransId" style="width: 280px">
              <Option
                v-for="item in adconverts"
                :value="item.appTransId"
                :key="item.appTransId"
                disabled>{{item.transName}}</Option>
            </Select>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="plan.bidtype === 3 && plan.landing_type === 'LINK'">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广落地页</span>
          </Col>
          <Col span="20">
            <input-len ref="lpurl" v-model="plan.lpUrl" placeholder="手动填写落地页或者使用系统内部生成落地页" :disabled="plan.innerUrl" :max="1024" :width="420"></input-len>
            <div class="col-check-box" v-if="!editState">
              <Checkbox v-model="plan.innerUrl" v-if="plan.landing_type === 'LINK'" @on-change="focuslpUrl">
                使用系统内部落地页
              </Checkbox>
            </div>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">出价模式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.ocpcLevel" type="button">
              <Radio :label="2" :disabled="editState">转化出价</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="plan.bidtype === 3">
          <Col span="3" class="col-item">
            <span class="item-field">转化类型</span>
          </Col>
          <Col span="12">

            <Select v-model="plan.transType" style="width: 180px">

                  <template v-if="plan.ch_platform_id === 3">
                  <Option :value="49" :disabled="editState">登录</Option>
                  <Option :value="26" :disabled="editState">付费</Option>
                </template>

                <template v-else>
                  <Option :value="4" :disabled="editState">激活</Option>
                  <Option :value="26" :disabled="editState">付费</Option>
                </template>

            </Select>

            <span v-if="plan.transType === 26" style="margin-left: 10px">
              <Checkbox disabled v-model="plan.transTypeAttribute">优化付费次数</Checkbox>
            </span>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="plan.bidtype === 3">
          <Col span="3" class="col-item">
            <Poptip
              trigger="hover"
              placement="top-start"
              width="410"
              word-wrap
              content="期望转化成本，累计转化数大于等于20进入该阶段，平台会根据出价智能竞价，计费方式仍按点击计费，请将该出价尽量与实际成本接近，出价高低会影响您获得的转化次数，若设置过低会减少转化次数。">
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field row-item-must">目标转化出价</span>
          </Col>
          <Col span="12">
            <Input v-model="plan.ocpcBid" @on-blur="inputTrim('ocpcBid', plan.ocpcBid, plan, true)" :placeholder="`0.3-99999.99之间的数字，精确到小数点后2位`" style="width: 420px" />
            <span style="padding-left: 8px">元/转化</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">深度转化出价</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-Switch v-model="plan.deep_bid_mode" @on-change="changDeepBid" :disabled="editState" />
          </Col>
        </Row>
        <template v-if="plan.deep_bid_mode">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">深度优化方式</span>
              </Col>
              <Col span="12" class="col-flex">
                <RadioGroup v-model="plan.deep_mode_type" type="button">
                  <Radio label="optimizeDeepTrans" :disabled="editState">优化深度转化</Radio>
                  <Radio label="useRoi" :disabled="editState">优化ROI</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="plan.deep_mode_type === 'useRoi'">
              <Col span="3" class="col-item">
                <span class="item-field">ROI系数</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  v-model="plan.roiRatio"
                  :max="3"
                  :min="0.01"
                  :step="0.1"
                  :precision="2"
                  :width="198"
                  placeholder="请输入系数，范围: 0.01 ~ 100 " />
              </Col>
            </Row>
            <template v-else>
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">深度转化目标</span>
                </Col>
                <Col span="12">
                  <Select v-model="plan.deepTransType" style="width: 180px">
                    <Option :value="26" :disabled="editState">付费</Option>
                  </Select>
                </Col>
              </Row>
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">深度转化目标出价</span>
                </Col>
                <Col span="12">
                  <input-number-plus
                    v-model="plan.deepOcpcBid"
                    :max="5"
                    :min="0.4"
                    :step="0.1"
                    :precision="2"
                    :width="100"
                    placeholder="输入深度价格" />
                  <span> 元</span>
                </Col>
              </Row>
            </template>
          </template>
      </template>
    </moduler>

    <!-- 落地页弹框 -->
    <landpage
      v-model="linkModel"
      @on-select="selectLinkLandPage"></landpage>

    <!-- 计划管家 -->
    <butler
      v-model="butlerModel"
      @on-cancel="butlerModel = false"
      @on-select="butlerSelect"></butler>

    <!-- 转化 -->
    <convert
      v-model="convertModel"
      :campaign="plan.campaignFeedId"
      :info="convertData"
      :converts="adconverts"
      :loading="converting"
      :account="plan.ad_account_id"
      @on-loading="loadConvert"
      @on-refresh="getAdConverts"></convert>

    <!-- 批量结果 -->
    <resulter
      v-model="model"
      :show="loading"
      title="建立推广单元结果反馈"
      head="推广单元创建结果"
      :columns="columns"
      :data="data"
      @on-retry="retry"
      @on-next="jump"></resulter>

    <div class="c-plan-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <ElButton type="default" @click="cannel">取消</ElButton>
          <ElButton type="primary" v-if="editState" :loading="saving" @click.stop="submit(0)">
            <span v-if="!saving">保存并关闭</span>
            <span v-else>提交中...</span>
          </ElButton>
          <ElButton type="primary" v-if="editState" :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">{{creativStat ? '保存并修改创意' : '保存并新建创意'}}</span>
            <span v-else>提交中...</span>
          </ElButton>
          <ElButton type="primary" v-else :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">保存并下一步</span>
            <span v-else>提交中...</span>
          </ElButton>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import opts from './plan_opts.js'
export default opts
</script>
<style lang='scss' scoped>
.item-span {
  padding-left: 30px;
  display: inline-block;
}

.item-link {
  cursor: pointer;
  color: #598fe6;
}

.c-plan-submit {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;

  .c-btns-submit {
    text-align: right;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

.item-flex-start {
  align-items: flex-start;

  .col-item {
    padding-top: 10px;
  }
}

.c-butler {
  margin-top: 20px;

  span {
    display: inline-block;
    max-width: 380px;
    line-height: 1.2;

    &.c-butler-del {
      margin-left: 20px;
      color: #ff0000;
      cursor: pointer;
    }
  }
}

.col-check-box {
  display: inline-block;
  margin-left: 12px;
}

.col-min-width {
  min-width: 680px;
}

.component-loading {
  position: relative;
  z-index: 9;
}

.conponent-blank {
  padding-top: 12px;

  .b-span {
    margin-right: 10px;
  }
}

.component-spin {
  z-index: 10;
}

.c-pop-tip {
  width: 100%;
}

.c-tag-item {
  width: 90%;
  margin: 8px 8px 0;
  padding: 2px 6px;
  display: block;
  font-size: 14px;
  height: 28px;
}
</style>
